import { cn } from '@/lib/utils'

/** Figma section headings — 42px Pretendard Bold, 100% line-height (Meet Ivy + feature pages). */
export function MarketingSectionTitle({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <h2 className={cn('marketing-section-title', className)}>{children}</h2>
}
